import { defaultCardStyle } from "components/ui/card";
import React from "react";

interface EventSectionProps {
    title: string;
    actions: React.ReactNode;
    children: React.ReactNode;
}

export const EventSection: React.FC<EventSectionProps> = props => (
    <section className={`${defaultCardStyle} p-4`}>
        <div className="flex flex-wrap items-center justify-between gap-2">
            <h2 className="text-base font-medium text-gray-900">{props.title}</h2>
            {props.actions}
        </div>
        {props.children}
    </section>
);
